import { HttpErrorResponse } from '@angular/common/http';
import { getErrorText, truncateMessage } from '@common/utils';
import { I18NextPipe } from 'angular-i18next';

export function getLoginErrorText(res: HttpErrorResponse, i18nPipe: I18NextPipe): string {
  if (!res) return '';

  const { error, status } = res || {};

  if (status === 503) {
    return i18nPipe.transform('common.unavailableService', { format: 'capitalize' });
  }

  if (status === 500) {
    return i18nPipe.transform('common.authenticationFailed', { format: 'capitalize' });
  }

  if (status === 440) {
    return error?.message || i18nPipe.transform('common.somethingWrong', { format: 'capitalize' });
  }

  return truncateMessage(getErrorText(error, i18nPipe.transform('common.somethingWrong', { format: 'capitalize' })));
}
